export default __webpack_public_path__ + "static/media/f-07.b9a701d2.jpg";